import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import internalPagesAnimation from '@app/shared/animations/internal.pages.animation';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
  animations: [internalPagesAnimation],
})
export class PortalComponent {
  getDepth(outlet: RouterOutlet) {
    return outlet.activatedRouteData.depth;
  }
}
